import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ExternalLinkIcon, AlertCircleIcon } from 'lucide-react';
// Easy to update: Just add new products to this array
const affiliateProducts = [{
  id: 1,
  name: 'Product Name',
  description: 'A brief description of this product and why it might be valuable for newsletter creators and content professionals.',
  imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop',
  affiliateLink: 'https://sovrn.co/10n7g0d',
  category: 'Tools & Resources'
}
// Add more products here as needed
// {
//   id: 2,
//   name: 'Another Product',
//   description: 'Description of another product...',
//   imageUrl: 'https://example.com/image.jpg',
//   affiliateLink: 'https://your-affiliate-link.com',
//   category: 'Category Name'
// },
];
export function AffiliateLinksPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-838">
      <Header data-id="element-839" />

      <main className="flex-grow pt-36 pb-24" data-id="element-840">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-841">
          {/* Page Header */}
          <div className="mb-12 text-center" data-id="element-842">
            <h1 className="font-serif text-5xl font-bold text-gray-900 mb-6" data-id="element-843">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-844">
                Recommended Products
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-845">
              Tools and resources we use and recommend for newsletter creators
              and content professionals.
            </p>
          </div>

          {/* FTC Disclosure */}
          <div className="mb-12 bg-blue-50 border border-blue-200 rounded-xl p-6" data-id="element-846">
            <div className="flex items-start" data-id="element-847">
              <AlertCircleIcon className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-848" />
              <div data-id="element-849">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-850">
                  Affiliate Disclosure
                </h2>
                <div className="text-gray-700 space-y-2" data-id="element-851">
                  <p data-id="element-852">
                    <strong data-id="element-853">Important:</strong> This page contains affiliate
                    links. We may earn a commission when you click on or make
                    purchases via these links, at no additional cost to you.
                  </p>
                  <p data-id="element-854">
                    We only recommend products and services that we genuinely
                    believe will provide value to newsletter creators and
                    content professionals. Our recommendations are based on our
                    own experience, research, and assessment of these products.
                  </p>
                  <p data-id="element-855">
                    The presence of an affiliate link does not influence our
                    editorial content or recommendations. We maintain full
                    editorial control and only feature products we would
                    recommend regardless of any affiliate relationship.
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-856">
                    This disclosure is in accordance with the Federal Trade
                    Commission's 16 CFR Part 255: "Guides Concerning the Use of
                    Endorsements and Testimonials in Advertising."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Products Grid */}
          {affiliateProducts.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-857">
              {affiliateProducts.map(product => <div key={product.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-858">
                  {/* Product Image */}
                  <div className="aspect-square overflow-hidden bg-gray-100" data-id="element-859">
                    <img src={product.imageUrl} alt={product.name} className="w-full h-full object-cover" data-id="element-860" />
                  </div>

                  {/* Product Info */}
                  <div className="p-6" data-id="element-861">
                    {product.category && <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full mb-3" data-id="element-862">
                        {product.category}
                      </span>}

                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-863">
                      {product.name}
                    </h3>

                    <p className="text-gray-600 mb-6" data-id="element-864">{product.description}</p>

                    {/* Buy Now Button */}
                    <a href={product.affiliateLink} target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center justify-center w-full px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors" data-id="element-865">
                      Buy Now
                      <ExternalLinkIcon className="ml-2 h-4 w-4" data-id="element-866" />
                    </a>

                    <p className="text-xs text-gray-500 mt-3 text-center" data-id="element-867">
                      Affiliate link - we may earn a commission
                    </p>
                  </div>
                </div>)}
            </div> : <div className="text-center py-16" data-id="element-868">
              <p className="text-gray-500 text-lg" data-id="element-869">
                No products available at this time. Check back soon!
              </p>
            </div>}

          {/* Additional Legal Information */}
          <div className="mt-16 bg-gray-50 rounded-xl p-8" data-id="element-870">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-871">
              Additional Information
            </h2>
            <div className="text-gray-700 space-y-3" data-id="element-872">
              <p data-id="element-873">
                <strong data-id="element-874">Our Commitment:</strong> We are committed to
                transparency and honesty in all our recommendations. While we
                may receive compensation through affiliate links, this does not
                affect the price you pay for any products or services.
              </p>
              <p data-id="element-875">
                <strong data-id="element-876">Your Trust Matters:</strong> We value your trust and
                only recommend products that we believe will genuinely benefit
                our audience. If you have any questions about our affiliate
                relationships or recommendations, please don't hesitate to
                contact us.
              </p>
              <p data-id="element-877">
                <strong data-id="element-878">No Obligation:</strong> You are under no obligation to
                purchase through our affiliate links. You can always search for
                and purchase products directly from the merchant if you prefer.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-879" />
    </div>;
}